module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-angry.00f20ea1.png";